module.exports = __webpack_public_path__ + "static/img/peo03@2x.c0679cf9.png";